import { getJsonTableColumn } from '../../api/Reporting/getJsonTableColumn.api';

async function getJson(url, reportId) {
	var columns;
	await getJsonTableColumn(reportId).then((data) => {
		columns = data;
	});
	console.log('cocolumnslumns', columns);

	const dashboardSpec = {
		xsd: 'https://ibm.com/daas/module/1.0/module.xsd',
		source: {
			id: reportId,
			srcUrl: {
				sourceUrl: url,
				mimeType: 'text/csv',
				property: [
					{
						name: 'headers',
						value: [
							{
								name: 'x-header-1',
								value: 'someheadervalue',
							},
							{
								name: 'x-header-2',
								value: 'someotherheadervalue',
							},
						],
					},
				],
			},
		},
		table: {
			column: columns,
			name: reportId,
		},
		label: reportId,
		identifier: reportId,
	};

	return dashboardSpec;
}

export default getJson;
